import { AxiosResponse } from "axios";
import { ReviewFormInputType } from "../pages/page-components/review/TabAddReview";
import httpUtil from "../utils/http.util";
import { IReviewsList } from "../helpers/types/global";

class ReviewService {
  fetchCategories() {
    return httpUtil.get("/reviewCategory/getAll");
  }

  createReview(data: ReviewFormInputType) {
    return httpUtil.post("/review/create", data, true);
  }

  fetchReviews(): Promise<AxiosResponse<{ data: IReviewsList[] }>> {
    return httpUtil.get("/review/getAll");
  }

  fetchDetails(id: string): Promise<AxiosResponse<{ data: IReviewsList }>> {
    return httpUtil.get(`/review/${id}`);
  }

  updateReview(id: string, data: ReviewFormInputType) {
    return httpUtil.patch(`/review`, id, data);
  }

  deleteReview(id: string) {
    return httpUtil.delete("/review", id);
  }
}
export default new ReviewService();
